<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>
		<Content class="app-content__main">
			<h1>{{supplierName}}</h1>

			<TableFuncs>
				<QueryCondition @query="query" @exportExcel="exportExcel" ref="queryCondition" />

				<Button type="primary" icon="ios-add-circle-outline" @click="addShow">新增广告</Button>
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>

				<template slot-scope="{ row, index }" slot="advertType">
					<span v-if="row.advertType=='splash'">开屏</span>
					<span v-if="row.advertType=='table'">插屏</span>
					<span v-if="row.advertType=='template'">信息流</span>
				</template>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
					<Button v-if="row.status==1" type="warning" size="small" style="margin-right: 5px"
						@click="updateStatus(row.id,0)">停用</Button>
					<Button v-if="row.status==0" type="success" size="small" style="margin-right: 5px"
						@click="updateStatus(row.id,1)">启用</Button>
					<Button type="error" size="small" style="margin-right: 5px" @click="delData(row.id)">删除</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="addStoreShow" :title="addForm.id?'编辑广告':'新增广告'">
			<Form ref="addForm" :model="addForm" :label-width="120" :rules="addRule">
				<FormItem label="投放渠道" prop="appStoreId">
					<Select v-model="addForm.appStoreId">
						<Option v-for="item in appStores" :value="item.id" :key="item.id">{{item.storeName}}</Option>
					</Select>
				</FormItem>
				<FormItem label="广告名称" prop="advertName">
					<Input v-model="addForm.advertName" placeholder="请输入广告名称"></Input>
				</FormItem>
				<FormItem label="广告key" prop="advertKey">
					<Input v-model="addForm.advertKey" placeholder="请输入广告key"></Input>
				</FormItem>
				<FormItem label="广告类型" prop="advertType">
					<Select v-model="addForm.advertType" style="width:200px">
						<Option v-for="item in advetTypes" :value="item.value" :key="item.value">{{ item.name }}
						</Option>
					</Select>
				</FormItem>
				<FormItem label="广告宽度" prop="width">
					<Input v-model="addForm.width" placeholder="请输入广告宽度"></Input>
				</FormItem>
				<FormItem label="广告高度" prop="height">
					<Input v-model="addForm.height" placeholder="请输入广告高度"></Input>
				</FormItem>
				<FormItem label="状态" prop="status">
					<i-switch v-model="addForm.status" size="large">
						<span slot="open">启用</span>
						<span slot="close">停用</span>
					</i-switch>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrUpdateData">确认提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition2'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import { ADVERT_TYPES } from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				advetTypes: ADVERT_TYPES,
				supplierName: this.$route.query.name,
				loading: false,
				queryParams:{
					appStoreId: '',
					advertName:'',
					advertKey:'',
					advertType: '',
					status: '',
					startDate:null,
					endDate:null
				},
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				addStoreShow: false,
				appStores: [],
				addForm: {
					appStoreId: '',
					advertKey: '',
					advertName: '',
					advertType: '',
					width: 0,
					height: 0,
					status: true,
				},
				addRule: {
					appStoreId: [
						{ required: true, message: '请选择投放渠道', trigger: 'blur' }
					],
					advertKey: [
						{ required: true, message: '请输入广告key', trigger: 'blur' }
					],
					advertName: [
						{ required: true, message: '请输入广告名称', trigger: 'blur' },
					],
					advertType: [
						{ required: true, message: '请选择广告类型', trigger: 'blur' },
					],
					width: [
						{ required: true, type: 'number', message: '请输入广告宽度', trigger: 'blur' },
					],
					height: [
						{ required: true, type: 'number', message: '请输入广告高度', trigger: 'blur' },
					],
					status: [
						{ required: true, type: 'boolean', message: '请选择状态', trigger: 'blur' }
					],
				}
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '投放渠道',
						key: 'appStoreName',
						align: 'center'
					},
					{
						title: '广告名称',
						key: 'advertName',
						align: 'center'
					},
					{
						title: '广告key',
						key: 'advertKey',
						align: 'center'
					},
					{
						title: '广告类型',
						slot: 'advertType',
						align: 'center'
					},
					{
						title: '广告宽度',
						key: 'width',
						align: 'center'
					},
					{
						title: '广告高度',
						key: 'height',
						align: 'center'
					},
					{
						title: '状态',
						key: 'status',
						align: 'center',
						render: (h, params) => {
							return h('span', params.row.status == 1 ? '启用' : '停用');
						}

					}, {
						title: '创建日期',
						key: 'createTime',
						align: 'center'
					},
					{
						title: '操作',
						slot: 'action',
						width: 200,
						align: 'center'
					}

				]
			}
		},
		created() {
			this.getData();
			this.getAllAppStore()
		},
		methods: {
			query(params) {
				this.queryParams = {
					appStoreId: params.appStoreId,
					advertName:params.advertName,
					advertKey:params.advertKey,
					advertType: params.advertType,
					status: params.status,
					startDate:params.dateRange[0]||null,
					endDate:params.dateRange[1]||null
				}
				this.refreshData()
			},
			exportExcel(params){
				const queryParams = {
					id: this.$route.query.id,
					page: this.pageNum,
					limit: this.pageSize,
					...params
				}
				api.statistics
					.exportSupplierAdvertExcel(queryParams)				
			},
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			getAllAppStore() {
				api.statistics
					.getAllUsedStores()
					.then(res => {
						this.appStores = res.data
					})
			},
			getData() {
				this.loading = true
				const params = {
					id: this.$route.query.id,
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.getSupplierAdvertPage(params)
					.then(res => {
						const result = res.data || {}
						this.totalRecord = result.totalRecordNum || 0
						this.queryData = result.records
					})
					.catch(err => {
						this.$Message.error('获取数据列表失败: ' + err.message)
					})
					.then(() => {
						this.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			addOrUpdateData() {
				const that = this
				that.$refs['addForm'].validate((valid) => {
					if (valid) {
						let params = { ...that.addForm }
						params.status = params.status ? 1 : 0
						params.supplierId = this.$route.query.id
						api.statistics
							.addOrEditSupplierAdvert(params)
							.then(res => {
								that.$Message.success('Success!');
								if (that.addForm.id) {
									//编辑
									that.queryData.forEach(item => {
										if (item.id == that.addForm.id) {
											item.status = that.addForm.status
											item.appStoreName = res.data.appStoreName
											item.advertKey = that.addForm.advertKey
											item.advertName = that.addForm.advertName
											item.advertType = that.addForm.advertType
											item.width = that.addForm.width
											item.height = that.addForm.height
										}
									})
								} else {
									//新增
									that.refreshData()
								}
								that.addStoreShow = false
							})
							.catch(err => {
								that.$Message.error('新增失败: ' + err.message)
							})

					}
				})
			},

			updateStatus(id, status) {
				const that = this
				api.statistics
					.addOrEditSupplierAdvert({ 'id': id, status: status })
					.then(res => {
						that.$Message.success('Success!');
						that.queryData.forEach(item => {
							if (item.id == id) {
								item.status = status
							}
						})
					})
			},
			addShow() {
				this.addForm = {
						appStoreId: '',
						advertKey: '',
						advertName: '',
						advertType: '',
						width: 0,
						height: 0,
						status: true,
					},
					this.addStoreShow = true
			},
			editData(rowData) {
				this.addForm = {
						id: rowData.id,
						appStoreId: rowData.appStoreId,
						advertKey: rowData.advertKey,
						advertName: rowData.advertName,
						advertType: rowData.advertType,
						width: rowData.width,
						height: rowData.height,
						status: rowData.status == 1 ? true : false,
					},
					this.addStoreShow = true

			},
			delData(id) {
				const that = this
				that.$Modal.confirm({
					title: '操作确认',
					content: '数据删除不可恢复，确定删除吗？',
					onOk: function() {
						api.statistics
							.delSupplierAdvert({ 'id': id })
							.then(res => {
								that.$Message.success('Success!');
								that.refreshData()
							})
					}
				})

			},
		},



	}
</script>
